module.exports = __webpack_public_path__ + "static/media/me.44db804e.jpg";